module.exports = __webpack_public_path__ + "img/20191226153251451.87ef4139.jpg";